import { AnalysisReportPrintDataOptionsType } from './AnalysisReportPrintDataOptionsType';

export interface IManualCodeInvoiceLineItemNotesDto {  
  InvoiceLineItemNotesId: Guid;
  InvoiceLineItemId: Guid;
  PrivateAuditorNotes: string;
  AuditorNotesReportLanguage: string;
  AnalysisReportPrintDataOptionsType: AnalysisReportPrintDataOptionsType;
  MarkImportant: boolean;
  PrintCommentsAuditorReport: boolean;
  IncludeAllAgentsCharges: boolean;
  PhaseHistory: string;
}

export class ManualCodeInvoiceLineItemNotesDto implements IManualCodeInvoiceLineItemNotesDto {
  InvoiceLineItemNotesId = '00000000-0000-0000-0000-000000000000';
  InvoiceLineItemId = '';
  PrivateAuditorNotes = '';
  AuditorNotesReportLanguage = '';
  AnalysisReportPrintDataOptionsType = AnalysisReportPrintDataOptionsType.DoNotPrint;
  MarkImportant = false;
  PrintCommentsAuditorReport = true;
  IncludeAllAgentsCharges = false;
  PhaseHistory = '';   
}
